<template>
  <div class="orientation-overlay">
    <div class="orientation-box">
      <p class="title">Please switch your device to landscape mode for the best experience.</p>
      <!-- <p class="hint">This game is best played in landscape mode.</p> -->
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.orientation-overlay {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(7, 23, 15, 0.78);
  backdrop-filter: blur(4px);
  z-index: 9999;
  padding: 24px;
}
.orientation-box {
  background: #0e2a1f;
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #e7f5ef;
  border-radius: 14px;
  padding: 18px 22px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.25);
  text-align: center;
}
.title {
  font-weight: 700;
  font-size: 16px;
  /* margin-bottom: 6px; */
}
.hint {
  font-size: 13px;
  opacity: 0.9;
}
</style>
